import { Button } from "@/components/ui/button"
import { Link } from "react-router"

export const Home = () => {
	return (
		<section className="mx-auto flex w-full max-w-2xl flex-col items-center gap-4 p-6 text-center">
			<h2 className="text-3xl font-semibold tracking-tight">Oblique</h2>
			<p className="text-muted-foreground">
				Real-time geometry collaboration across desktop and web.
			</p>
			<div className="flex flex-wrap items-center justify-center gap-2">
				<Button asChild>
					<Link to="/download">Download Origin</Link>
				</Button>
				<Button variant="outline" asChild>
					<Link to="/login">Open web app</Link>
				</Button>
			</div>
		</section>
	)
}
